import { Record } from 'immutable';

import { ConnectorListEntity } from '../components/connector-list/connector-list.entity';

export const ConnectorSliceKey = 'main';

export interface IConnectorOriginalSliceState {
	loading: boolean;
	list: ConnectorListEntity;
	includePublicProjects: boolean;
	isLoadingPublicProjectDetails: boolean;
}

export const defaults: IConnectorOriginalSliceState = {
	loading: false,
	list: ConnectorListEntity.build([]),
	includePublicProjects: false,
	isLoadingPublicProjectDetails: false,
};

export class ConnectorOriginalSliceState extends Record<IConnectorOriginalSliceState>(
	defaults
) {
	public static readonly key = ConnectorSliceKey;

	public setLoading(isLoading: boolean): ConnectorOriginalSliceState {
		return this.set('loading', isLoading);
	}

	public setConnectorList(
		connectorList: ConnectorListEntity
	): ConnectorOriginalSliceState {
		return this.set('list', connectorList);
	}

	public toggleIncludePublicProjects(
		includePublicProjects: boolean
	): ConnectorOriginalSliceState {
		return this.set('includePublicProjects', includePublicProjects);
	}

	public setIsLoadingPublicProjectDetails(
		isLoading: boolean
	): ConnectorOriginalSliceState {
		return this.set('isLoadingPublicProjectDetails', isLoading);
	}
}
